import request from "@/utils/request"

export function saveMaterialsCatalog(params) {
    return request({
        url: '/bd/save/catalog',
        method: 'post',
        data: params,
    })
}

export function queryMaterialsCatalogPage(params) {
    return request({
        url: '/bd/query/catalog/page',
        method: 'post',
        data: params,
    })
}

export function queryMaterialsCatalogList(params) {
    return request({
        url: '/bd/query/catalog/list',
        method: 'post',
        data: params,
    })
}

export function removeMaterialsCatalog(params) {
    return request({
        url: '/bd/remove/catalog',
        method: 'post',
        data: params,
    })
}

export function saveMaterialsInfo(params) {
    return request({
        url: '/bd/save/materials',
        method: 'post',
        data: params,
    })
}

export function queryMaterialsInfoPage(params) {
    return request({
        url: '/bd/query/materials/page',
        method: 'post',
        data: params,
    })
}

export function queryMaterialsByItem(params) {
    return request({
        url: '/bd/query/materials/item',
        method: 'post',
        data: params,
    })
}


export function removeMaterialsInfo(params) {
    return request({
        url: '/bd/remove/materials',
        method: 'post',
        data: params,
    })
}


export function saveItemClassify(params) {
    return request({
        url: '/bd/save/classify',
        method: 'post',
        data: params,
    })
}

export function queryItemClassifyPage(params) {
    return request({
        url: '/bd/query/classify/page',
        method: 'post',
        data: params,
    })
}

export function queryItemClassifyList(params) {
    return request({
        url: '/bd/query/classify/list',
        method: 'post',
        data: params,
    })
}

export function removeItemClassify(params) {
    return request({
        url: '/bd/remove/classify',
        method: 'post',
        data: params,
    })
}


export function saveItemInfo(params) {
    return request({
        url: '/bd/save/item',
        method: 'post',
        data: params,
    })
}

export function queryItemInfoPage(params) {
    return request({
        url: '/bd/query/item/page',
        method: 'post',
        data: params,
    })
}

export function removeItemInfo(params) {
    return request({
        url: '/bd/remove/item',
        method: 'post',
        data: params,
    })
}

export function queryReceiveInitInfo(params) {
    return request({
        url: '/bd/receive/init/info',
        method: 'post',
        data: params,
    })
}

export function saveStoreSetting(params) {
    return request({
        url: '/bd/save/storeSetting',
        method: 'post',
        data: params,
    })
}


export function queryStoreSettingPage(params) {
    return request({
        url: '/bd/query/storeSetting/page',
        method: 'post',
        data: params,
    })
}

export function queryStoreSettingOne(params) {
    return request({
        url: '/bd/query/storeSetting/one',
        method: 'post',
        data: params,
    })
}

export function removeStoreSetting(params) {
    return request({
        url: '/bd/remove/storeSetting',
        method: 'post',
        data: params,
    })
}

export function queryDictInfo(params) {
    return request({
        url: '/dict/query',
        method: 'post',
        data: params,
    })
}
